import { css } from '@emotion/core';
import styleService from '@nykaa/deals-utils/styles';
import styled from '../../theme';
const { getPaddingStyles, getMarginStyles, getFontStyles, getBKGStyles, getBorderStyles, addAlpha, getIndividualBorderRadius, } = styleService.utils;
export const CardWrapper = styled.div `
  position: relative;
  display: inline-block;
  width: ${({ width }) => `${width}px`};
  margin-right: ${({ interItem, isDesktop }) => (isDesktop ? '1.5rem' : interItem.web)};
  ${({ padding }) => getPaddingStyles(padding)};
  a {
    text-decoration: none;
  }
  .width-limiter {
    max-width: 100%;
    display: block !important;
  }
  :first-of-type {
    margin-left: ${({ isDesktop }) => (isDesktop ? '3rem' : '1.25rem')};
  }
  :last-of-type {
    margin-right: ${({ isDesktop }) => (isDesktop ? '3rem' : '1.25rem')};
  }
  @media only screen  and (min-width : 1600px) {
    margin-right: ${({ interItem }) => (interItem.web)};
    :first-of-type {
      margin-left: auto;
    }
    :last-of-type {
      margin-right: auto;
    }
  }
`;
export const basicButton = css `
  display: inline-block;
  background: none;
  border: none;
`;
export const ButtonGroup = styled.div `
  width: 100%;
  position: relative;
  bottom: 0px;
  height: ${({ isDesktop }) => (isDesktop ? '2.5rem' : '2rem')};
  display: flex;
  height: ${({ onlyWishlist }) => (onlyWishlist && '2rem')};

  ${({ margin }) => getMarginStyles(margin)};
  .add_to_cart {
    ${basicButton};
    ${({ padding }) => getPaddingStyles(padding)};
    ${({ text }) => getFontStyles(text)};
    width: calc(100% - 2rem);
    flex-basis: 100%;
    text-overflow: ellipsis;
    max-width: -webkit-fill-available;
    clear: both;
    display: inline-block;
    overflow: hidden;
    border-radius: ${({ cornerRadius }) => cornerRadius.web};
    white-space: nowrap;
    ${({ background }) => getBKGStyles(background)};
    .disabled {
      color: gray;
    }
  }
  .wishlist-wrapper {
    ${({ border }) => getBorderStyles(border)};
    margin-right: ${({ interItem, onlyWishlist }) => !onlyWishlist && (interItem === null || interItem === void 0 ? void 0 : interItem.web)};
    border-radius: ${({ cornerRadius }) => cornerRadius.web};
  .wishlist {
    ${basicButton}
    width: ${({ isDesktop }) => (isDesktop ? '2.375rem' : '1.875rem')};
    height: ${({ isDesktop }) => (isDesktop ? '2.375rem' : '1.875rem')};
    ${({ padding }) => getPaddingStyles(padding)};
    ${({ text }) => getFontStyles(text)};
    mask-image: ${({ isProductInWishList }) => (isProductInWishList ? 'url(https://www.nykaa.com/media/wysiwyg/2022/core/heart-filled.svg)' : 'url(https://www.nykaa.com/media/wysiwyg/2022/core/heart-plus.svg)')}; 
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size:  ${({ isDesktop, wishlistIconSize }) => (isDesktop ? '24px 24px' : `${wishlistIconSize}px ${wishlistIconSize}px`)};
    background-color: ${({ background }) => background === null || background === void 0 ? void 0 : background.colorStart};
  }
  .nf-wishlist { 
    width: 2rem;
    height: 2rem;
  }
}
.nf-wishlist-wrapper {
  background-color: #fff;
}
`;
export const ProductContent = styled.div `
flex-grow: 1;
border: none;
background: 0 0;
margin: 0;
-webkit-box-shadow: none;
box-shadow: none;
font-size: 1em;
border-radius: 0;
max-width: 100%;
overflow: hidden;
.header {
  display: inline-block;
  ${({ padding }) => getPaddingStyles(padding)};
  min-height: 39.5px;
  ${({ brandStyle }) => getFontStyles(brandStyle)};
  vertical-align: top;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${({ productStyle }) => productStyle.maxLines.web};
  line-height: ${({ brandStyle }) => brandStyle.font.web.lineHeight} !important;

  span { 
    margin-right: 4px;
  }
  .product-name {
  display: inline;
  ${({ productStyle }) => getFontStyles(productStyle)};
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
  -webkit-line-clamp: ${({ brandStyle }) => brandStyle.maxLines.web};
  line-height: ${({ productStyle }) => productStyle.font.web.lineHeight} !important;
}
.nf-product-name {
  white-space: nowrap;
  display: inline-block;
  vertical-align: top;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;  line-height: ${({ brandStyle }) => brandStyle.font.web.lineHeight} !important;
  -webkit-line-clamp: ${({ productStyle }) => productStyle.maxLines.web};
  span {
    margin-right: 0px;
  }
}
.nf-brand-name { 
  ${({ brandStyle }) => getFontStyles(brandStyle)};
  ${({ brandStyle }) => getFontStyles(brandStyle)};
  display: inline-block;
  vertical-align: top;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${({ brandStyle }) => brandStyle.maxLines.web};
  line-height: ${({ brandStyle }) => brandStyle.font.web.lineHeight} !important;
  span { 
    margin-right: 0px;
  }
}
}
.outsidetag {
   display: flex;
}
.nf-header {
  min-height: auto !important;
}
`;
export const ProductCardWrapper = styled.div `
    max-width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 0;
    border: none;
    border-radius: 0.58571429rem;
    z-index: '';
    cursor: ${({ isDesktop }) => (isDesktop && 'pointer')};
   }
   .nf-wishlist-button-wrapper {
     position: absolute;
     top: 0;
     right: 0;
   }
   .product-image{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: ${({ width, border }) => (border && (border === null || border === void 0 ? void 0 : border.alpha) === 0 ? `calc(calc(${width}px - 2*${border.width.web}) - 1px)` : `calc(${width}px - 1px)`)};
    position: relative;
    aspect-ratio: 3/4;
    background: #fff;
    box-sizing: border-box;
    ${({ border }) => border && (border === null || border === void 0 ? void 0 : border.alpha) !== 0 && getBorderStyles(border)}
    border-radius: ${({ cornerRadius }) => cornerRadius && (cornerRadius === null || cornerRadius === void 0 ? void 0 : cornerRadius.web)};
    ${({ individualCornerRadius }) => individualCornerRadius && getIndividualBorderRadius(individualCornerRadius)};
    ${({ highlightPosition }) => highlightPosition === 'top' && `
       border-top-left-radius: 0rem;
       border-top-right-radius: 0rem;
       border-top: 0rem;
    `}

    .product-head{
     flex: 1;
     z-index: 1;
     display: flex;
     visibility : ${({ tagText }) => (tagText ? 'visible' : 'hidden')};
    }
    img {
      width: 100%;
    }
   }

`;
export const ImageContainer = styled.div `
.container {
  display: flex;
  background: linear-gradient(0deg, ${({ overlay }) => addAlpha(overlay === null || overlay === void 0 ? void 0 : overlay.color, overlay === null || overlay === void 0 ? void 0 : overlay.alpha)}, ${({ overlay }) => addAlpha(overlay === null || overlay === void 0 ? void 0 : overlay.color, overlay === null || overlay === void 0 ? void 0 : overlay.alpha)}), url(${({ imageUrl }) => imageUrl});
  height: ${({ isHighlight, width, border }) => (isHighlight ? `calc(${width}px - 22px)` : `calc(calc(${width}px - 2*${(border && border.width.web) || '0px'}) - 1px)`)};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: inherit;
  align-self: flex-end;
  flex-direction: column;
  border-radius: ${({ cornerRadius, border }) => { var _a; return ((border === null || border === void 0 ? void 0 : border.alpha) === 0 || ((_a = border === null || border === void 0 ? void 0 : border.width) === null || _a === void 0 ? void 0 : _a.web) === '0px') && (cornerRadius === null || cornerRadius === void 0 ? void 0 : cornerRadius.web); }};
  ${({ individualCornerRadius }) => individualCornerRadius && getIndividualBorderRadius(individualCornerRadius)};
  ${({ highlightPosition }) => highlightPosition === 'top' && `
  border-top-left-radius: 0rem;
  border-top-right-radius: 0rem;
  border-top: 0rem;
`}
}
.rating-sticker-highlight-wrapper {
  position: absolute;
  bottom: 0;
  width: fill-available;
}
.rating-sticker-wrapper {
  display: flex;
  flex-direction: row;
  flex: 1;
}
.sticker-container {
  flex: 2;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
}
 .ratings-container {
  flex: 1;  
  align-self: flex-end;
  width: -webkit-fill-available;
}
`;
